import { required } from "../../shared/src/codecs/types/required";
import { TTypeOfCodec } from "../../shared/src/codecs/codec";
import { uuid } from "../../shared/src/codecs/types/uuid";
import { union } from "../../shared/src/codecs/types/union";
import { nullCodec } from "../../shared/src/codecs/types/nullCodec";
import { boolean } from "../../shared/src/codecs/types/boolean";
import { string } from "../../shared/src/codecs/types/string";
import { longString } from "../../shared/src/codecs/types/longString";
import { integer } from "../../shared/src/codecs/types/integer";
import { dateTime } from "../../shared/src/codecs/types/dateTime";
import { literal } from "../../shared/src/codecs/types/literal";
import { email } from "../../shared/src/codecs/types/email";
import { phoneNumber } from "../../shared/src/codecs/types/phoneNumber";

export const ManagementPackRoute = union([
    literal("online_form"),
    literal("pdf_form"),
    literal("email"),
    literal("post"),
    literal("portal"),
    literal("unknown"),
]);
export type TManagementPackRoute = TTypeOfCodec<typeof ManagementPackRoute>;

export const ManagementCompanyFormType = union([
    literal("lpe1"),
    literal("fme1"),
]);
export type TManagementCompanyFormType = TTypeOfCodec<typeof ManagementCompanyFormType>;

export const ManagementCompanyType = union([
    literal("management_company"),
    literal("managing_agent"),
    literal("freeholder"),
    literal("unknown"),
]);
export type TManagementCompanyType = TTypeOfCodec<typeof ManagementCompanyType>;

export const ManagementCompany = required({
    id: uuid(),
    name: string(),
    name_normalised: string(),
    address: string(),
    phone_number: union([string(), nullCodec()]),
    email: union([string(), nullCodec()]),
    website: union([string(), nullCodec()]),
    company_type: ManagementCompanyType,
    deals_with_ground_rent: union([boolean(), nullCodec()]),
    deals_with_service_charge: union([boolean(), nullCodec()]),
    management_pack_route: ManagementPackRoute,
    management_pack_url: union([string(), nullCodec()]),
    management_pack_email: union([string(), nullCodec()]),
    management_pack_notes: longString(),
    lpe1_cost_pence: union([integer(), nullCodec()]),
    fme1_cost_pence: union([integer(), nullCodec()]),
    consent_to_transfer_instructions: longString(),
    consent_to_transfer_cost_pence: union([integer(), nullCodec()]),
    consent_to_remortgage_instructions: longString(),
    consent_to_remortgage_cost_pence: union([integer(), nullCodec()]),
    notes: longString(),
    created_at: dateTime(),
    updated_at: dateTime(),
});
export type TManagementCompany = TTypeOfCodec<typeof ManagementCompany>;

export const CasesManagementCompanyLink = required({
    id: uuid(),
    case_id: uuid(),
    management_company_id: uuid(),
    form_type: union([ManagementCompanyFormType, nullCodec()]),
    contact_name: string(),
    contact_phone_number: union([phoneNumber(), nullCodec()]),
    contact_email: union([email(), nullCodec()]),
    requires_apportionment_statement: union([boolean(), nullCodec()]),
    client_has_share_of_the_freehold: union([boolean(), nullCodec()]),
    management_company_contacted: boolean(),
    pack_ordered: union([dateTime(), nullCodec()]),
    consent_obtained: union([dateTime(), nullCodec()]),
    consent_not_required: boolean(),
    linked_document_id: union([uuid(), nullCodec()]),
    created_at: dateTime(),
    updated_at: dateTime(),
});
export type TCasesManagementCompanyLink = TTypeOfCodec<typeof CasesManagementCompanyLink>;

export const CaseManagementCompanyJoined = required({
    link: CasesManagementCompanyLink,
    company: ManagementCompany,
});
export type TCaseManagementCompanyJoined = TTypeOfCodec<typeof CaseManagementCompanyJoined>;
